<template>
  <v-card @click="goToPage" :style="[toPage ? {'cursor': 'pointer', 'border-radius': '8px'} : {'border-radius': '8px'}]">
    <v-card-title>
      <div class="layout column ma-0 justify-space-between pb-1">
        <div class="rectangle-5" :style="{ backgroundColor: color }"></div>
        <div class="title">{{ title }}</div>
        <p v-if="description" class="description">{{ description }}</p>
        <v-container fluid>
          <v-layout row wrap align-center>
            <v-flex xs12>
              <div style="background-color: #fff3cd; padding: 20px; border-radius: 10px;  border: 1px solid #ffe69c;"><span style="color: #624a03"><v-icon>info</v-icon>&nbsp;&nbsp; Os números de leads e conversões <b>podem levar até 1 dia útil bancário para serem atualizados</b>.</span></div>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center style="margin-left: 50px;">
            <v-flex xs6>
              <v-subheader></v-subheader>
            </v-flex>
            <v-flex xs6>
              <v-select
                :loading="isLoading"
                v-model="select"
                :hint="`Exibindo estatísticas para ${select.title}`"
                :items="offers"
                item-text="title"
                item-value="id"
                label="Exibindo estatísticas para"
                persistent-hint
                return-object
                single-line
                @change="handleSelectChange"
              ></v-select>
              
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-card-title>
    <v-layout row wrap style="margin-left: 20px; margin-right: 5px;">
      <v-flex v-if="this.select.id == 0" sm3 xs12 mt-2 pt-0>
        <v-card class="hero-statics" style="background-color: #fbb2b4;">
          <v-card-title primary-title>
            <div>
              <span style="font-weight: 500; font-size: 12pt; color: #1c1c1c;">Leads</span>
              <h3 style="font-weight: 600; margin-top: -5px;">{{ totalClicks }}</h3>
            </div>
          </v-card-title>
          <div style="display: flex; justify-content: flex-end; padding: 0 10px 10px 0; margin-top: -20px;">
            <span><v-icon color="#f7464a">circle</v-icon></span>
          </div>
        </v-card>
      </v-flex>
      <v-flex v-for="(item, index) in GoalsCards" :key="index" sm3 xs12 mt-2 pt-0>
        <v-card class="hero-statics" :style="{ backgroundColor: item.totalPayout > 0 ? '#a7bad7' : '#FFF' }">
          <v-card-title primary-title>
            <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
              <div style="flex-shrink: 1;">
                <span :style="{ fontWeight: 500, fontSize: '12pt', color: item.totalPayout > 0 ? '#1c1c1c' : '#393939' }">{{ transformString(item.goal) }}</span>
              </div>
              <div>
                <h3 :style="{ fontWeight: 600, marginTop: '-5px', color: item.totalPayout > 0 ? '#1c1c1c' : '#393939'}">{{ item.totalConversions }}</h3>
              </div>
            </div>
          </v-card-title>
          <div style="display: flex; justify-content: flex-end; padding: 0 10px 10px 0; margin-top: -20px;">
            <span><v-icon :style="{ color: item.totalPayout > 0 ? '#297ec4' : '#f7464a' }">circle</v-icon></span>
          </div>
        </v-card>
      </v-flex>
      <v-flex v-if="this.select.id == 0" sm3 xs12 mt-2 pt-0>
        <v-card class="hero-statics" color="#a7bad7">
          <v-card-title primary-title>
            <div>
              <span style="font-weight: 500; font-size: 12pt; color: #1c1c1c;">Conversões</span>
              <h3 style="font-weight: 600; margin-top: -5px; color:#1c1c1c">{{ totalConversions }}</h3>
            </div>
          </v-card-title>
          <div style="display: flex; justify-content: flex-end; padding: 0 10px 10px 0; margin-top: -20px;">
            <span><v-icon color="#297ec4">circle</v-icon></span>
          </div>
        </v-card>
      </v-flex> 
    </v-layout>
    <v-container fluid>
      <v-layout row wrap align-center>
        <v-flex v-if="hasStatics" xs12>
          <apexchart width="100%" type="area" :options="options" :series="series"></apexchart>
        </v-flex>
        <v-flex v-else xs12>
          <p style="text-align: center;">Nenhuma conversão ou leads registrados no período selecionado.</p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
  props: {
    dateTo: String,
    dateFrom: String,
    needsRefresh: Array,
    icon: String,
    title: String,
    total: Number,
    cancelledAmount: Number,
    reachedAmount: Number,
    lines: Array,
    caption: String,
    color: String,
    description: String,
    linearStatistic: {
      type: Boolean,
      default: true
    },
    todayBalance: {
      type: Number,
      default: 0
    },
    toPage: String
  },

  data() {
    return {
      isLoading: false,
      beginDate: null,
      endDate: null,
      hasStatics: false,
      offers: [{ id: 0, title: 'Todas as ofertas' }],
      totalClicks: 0,
      totalConversions: 0,
      GoalsCards: [],
      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: []
        },
        colors: ['#f7464a', '#297ec4']
      },
      series: [
        {
          name: 'Leads',
          data: []
        },
        {
          name: 'Conversões',
          data: []
        }
      ],
      select: { id: null, title: 'Todas as ofertas' }
    };
  },

  watch: {
    needsRefresh(newValue, oldValue) {

        this.$emit("needsRefresh-received", newValue);
        this.endDate = this.$store.getters.activePageFilters.dateRange[1];
        this.beginDate = this.$store.getters.activePageFilters.dateRange[0];
        this.resetStatics();
        this.getStatics();
    },
  },

  mounted() {
    this.endDate = this.$store.getters.activePageFilters.dateRange[1];
    this.beginDate = this.$store.getters.activePageFilters.dateRange[0];

    this.getOffers();
    this.getStatics();
  },

  methods: {
    transformString(inputString) {

        var modifiedString = inputString.replace(/[-_]/g, ' ');

        modifiedString = modifiedString.replace(/(^|\s)\S/g, (match) => match.toUpperCase());

        return modifiedString;
    },
    getGoalsCards(offerId){
      this.isLoading = true;
      axios
    .post('https://api.consigmais.com.br/ds/affiseConversions/totalByGoal', { 
        offerId: offerId,
        dateTo: this.endDate,
        dateFrom: this.beginDate
     })
    .then((response) => {
      if (response.data.length > 0) {
        response.data.sort((a, b) => b.totalConversions - a.totalConversions);

        const indexPayoutGreaterThanZero = response.data.findIndex((item) => item.totalPayout > 0);

        if (indexPayoutGreaterThanZero !== -1) {
          response.data.splice(indexPayoutGreaterThanZero + 1);
        }

        this.GoalsCards = response.data;
        this.isLoading = false;
      }
    })
    .catch((error) => {
      this.isLoading = false;
      console.error(error);
      this.$notifyUser({
        type: 'error',
        message: 'Ocorreu um erro ao obter as conversões'
      });
    });
    },
    getStatics() {
      this.isLoading = true;
      if (this.select.id !== 0) {
        this.getGoalsCards(this.select.id);
        axios
          .post('https://api.consigmais.com.br/ds/affiseConversions/totalByOffer', { 
              offerId: this.select.id,
              dateTo: this.endDate,
              dateFrom: this.beginDate
           })
          .then((response) => {
            if (response.data.length > 0) {
              this.hasStatics = true;
              response.data.forEach((obj) => {
                const formattedDate = moment(obj.date, 'YYYY-MM-DD').format('DD/MM/YYYY');

                this.series[0].data.push(obj.totalClicks);
                this.series[1].data.push(obj.totalConversions);
                this.options.xaxis.categories.push(formattedDate);
                this.totalClicks += parseInt(obj.totalClicks);
                this.totalConversions += parseInt(obj.totalConversions);
              });
              this.isLoading = false;
            } else {
              this.resetStatics();
              this.isLoading = false;
            }
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error);
            this.$notifyUer({
              type: 'error',
              message: 'Ocorreu um erro ao obter as conversões'
            });
          });
      } else {
        axios
          .post('https://api.consigmais.com.br/ds/affiseConversions/totalByAffiliate', {
            dateTo: this.endDate,
            dateFrom: this.beginDate
          })
          .then((response) => {
            if (response.data.length > 0) {
              this.hasStatics = true;
              response.data.forEach((obj) => {
                const formattedDate = moment(obj.date, 'YYYY-MM-DD').format('DD/MM/YYYY');

                this.series[0].data.push(obj.totalClicks);
                this.series[1].data.push(obj.totalConversions);
                this.options.xaxis.categories.push(formattedDate);
                this.totalClicks += parseInt(obj.totalClicks);
                this.totalConversions += parseInt(obj.totalConversions);
              });
              this.isLoading = false;
            } else {
              this.resetStatics();
              this.isLoading = false;
            }
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error);
            this.$notifyUser({
              type: 'error',
              message: 'Ocorreu um erro ao obter as conversões'
            });
          });
      }
    },
    handleSelectChange() {
      this.resetStatics();
      this.getStatics();
    },
    resetStatics() {
      this.hasStatics = false;
      this.series[0].data = [];
      this.series[1].data = [];
      this.options.xaxis.categories = [];
      this.GoalsCards = [];
      this.totalClicks = 0;
      this.totalConversions = 0;
    },
    getOffers() {
      axios
        .post('https://api.consigmais.com.br/ds/indication/offers')
        .then((response) => {
          response.data.forEach((obj) => {
            this.offers.push(obj);
          });
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    goToPage() {
      if (this.toPage) {
        this.$router.push(this.toPage);
      }
    },
    getPercent(value) {
      let p = 0;
      if (value > 0) {
        p = value / this.total;
      }
      return p;
    }
  }
};
</script>

<style scoped>
.corner {
  margin-top: -7px !important;
  margin-right: -7px !important;
  height: 60px;
  width: 95px;
  float: right;
}

.description {
  font-size: 15px;
  margin-top: 5px;
  color: #555;
}

.rectangle-5 {
  background-color: green;
  border-radius: 0px 30px 30px 0px;
  height: 78px;
  width: 9px;
  margin-left: -16px;
}

.title {
  padding-left: 10px;
  margin-top: -70px;
}

.headline {
  padding-left: 10px;
}

.subheadline {
  padding-left: 10px;
  color: #656565;
  font-weight: 500;
  left: 1px;
  letter-spacing: 0;
}

h3 {
  color: black;
  font-weight: 600;
  font-size: xx-large !important;
}

.hero-statics {
  /* background-color: #F1F1F1; */
  min-width: 180px;
  border-radius: 15px;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ConversionStatsCard.vue